import { LoginPage, LoginPageProps } from '@jana-technology/platform-ui'

/**
 * Extra validation for user provided redirection URL
 * @param url - string representing the URL to return to after login.
 * @returns whether the returnTo URL is on the same host as the current window location.
 */
const isValidReturnTo = (url: string): boolean => {
  // Check if the returnTo URL is a valid URL
  const parsedUrl = new URL(url, window.location.origin)

  // Ensure the URL belongs to the same host
  return parsedUrl.origin === window.location.origin
}

/**
 * Login "landing" that notify users that they will need to go
 * onto another domain to complete authentication process.
 *
 * Note that we have two "login" pages. One here and another
 * hosted by the authentication provider. When making changes to
 * the login pages, one should ensure that they do not forget
 * that they may also need to modify the other login page.
 * (i.e. maintaining style consistency)
 */
const LoginLandingPage = () => {
  const urlParams = new URLSearchParams(window.location.search)
  const returnTo = urlParams.get('returnTo')

  const sanitizedReturnTo =
    returnTo != null && isValidReturnTo(returnTo) ? returnTo : undefined

  const redirectLoginOptions: LoginPageProps['appState'] = {
    returnTo: sanitizedReturnTo
  }

  return (
    <LoginPage
      product={'TIMP'}
      footing='Forgot your password? Contact an admin to have it reset.'
      appState={redirectLoginOptions}
    />
  )
}

export default LoginLandingPage
